export default __webpack_public_path__ + "static/media/cristor.477917de.svg";